var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "w-full" }, [
    _vm.membershipDiscount > 0
      ? _c("tr", [
          _c(
            "td",
            {
              staticClass:
                "text-right px-4 py-4 align-top border-t border-gray-200 whitespace-no-wrap",
            },
            [
              _c("div", { staticClass: "flex items-start justify-between" }, [
                _c("span", [
                  _vm._v(
                    "\n                    Membership Discount\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n                    - £" +
                      _vm._s(_vm.formattedMembershipDiscount) +
                      "\n                "
                  ),
                ]),
              ]),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customerCredit > 0
      ? _c("tr", [
          _c(
            "td",
            {
              staticClass:
                "text-right px-4 py-4 align-top border-t border-gray-200 whitespace-no-wrap",
            },
            [
              _c("div", { staticClass: "flex items-start justify-between" }, [
                _c("span", [
                  _vm._v(
                    "\n                    Account Credit\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n                    - £" +
                      _vm._s(_vm.formattedCustomerCredit) +
                      "\n                "
                  ),
                ]),
              ]),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("tr", [
      _c(
        "td",
        {
          staticClass:
            "text-right px-4 py-4 align-top border-t border-gray-200",
        },
        [
          _c("div", { staticClass: "flex items-start justify-between" }, [
            _c("span", { staticClass: "font-semibold" }, [
              _vm._v("\n                    Total\n                "),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n                    £" +
                  _vm._s(_vm.formattedTotal) +
                  "\n                "
              ),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }